<template>
  <div>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-3">
        <v-container>
          <h2 class="black--text">Rekap proses pelaksanaan pendampingan IHT</h2>
          <v-alert v-if="!dinasId" dense text color="blue" class="my-5 mb-7 body-2">
            <v-row no-gutters align="center">
              <v-col class="grow black--text">
                Silahkan lengkapi informasi laporan IHT Balai melalui tombol berikut
              </v-col>
              <v-col class="shrink">
                <v-btn depressed small color="info" dark @click="onEdit">
                  <v-icon small left class="mr-1">mdi-pencil</v-icon> Lengkapi
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>
          <v-row :class="[dinasId ? 'mt-3' : '']">
            <v-col v-for="(info, id) in infos" :key="id" cols="12" :lg="info.size || 6">
              <div class="body-2 grey--text text--darken-1">{{ info.label }}</div>
              <div v-if="!info.value" class="orange--text"><em>Belum dilengkapi</em></div>
              <div v-else-if="info.type === 'chip'">
                <v-chip :color="info.color">{{ info.value }}</v-chip>
              </div>
              <div v-else class="body-1 black--text" v-html="info.value"></div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <base-modal-full ref="modal" title="Laporan IHT Balai" @save="onSave">
      <form-laporan ref="formulir" :detail="formulir['detail']" :masters="masters" />
    </base-modal-full>
  </div>
</template>

<script>
import FormLaporan from '../forms/Laporan';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ComponentBalai',
  components: { FormLaporan },
  props: {
    dinasId: {
      default: null,
    },
  },
  data() {
    return {
      formulir: {},
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    ...mapState('iht', {
      monev: (state) => state.monev,
    }),

    infos() {
      return [
        {
          label: 'Total sekolah binaan',
          value: this.monev.jml_sekolah
            ? `<span class="font-weight-medium">${this.monev.jml_sekolah} Sekolah</span>`
            : '',
        },
        {
          label: 'Total peserta IHT',
          value: this.monev.jml_peserta
            ? `<span class="font-weight-medium">${this.monev.jml_peserta} Orang</span>`
            : '',
        },
        {
          label: 'Tanggal mulai pelaksanaan IHT',
          value: this.monev.tgl_mulai
            ? `<span class="font-weight-medium">${this.$localDate(this.monev.tgl_mulai)}</span>`
            : '',
        },
        {
          label: 'Tanggal selesai pelaksanaan IHT',
          value: this.monev.tgl_mulai
            ? `<span class="font-weight-medium">${this.$localDate(this.monev.tgl_selesai)}</span>`
            : '',
        },
        {
          label: 'Moda Pelaksanaan IHT',
          value: this.$getDeepObj(this.monev, 'm_monev_moda_psp.data.keterangan') || '',
          type: 'chip',
          color: 'success',
        },
        {
          size: 12,
          label: 'Hal-hal yang sudah efektif',
          value: this.monev.catatan_efektif ? `<p class="mb-0 text-justify">${this.monev.catatan_efektif}</p>` : '',
        },
        {
          size: 12,
          label: 'Hal-hal yang perlu ditingkatkan',
          value: this.monev.catatan_perbaikan ? `<p class="mb-0 text-justify">${this.monev.catatan_perbaikan}</p>` : '',
        },
      ];
    },
  },
  created() {
    if (!this.dinasId) {
      this.getMasters(['monev_moda_psp'].join(';'));
    }

    let params = {};
    if (this.dinasId) {
      params['dinas_id'] = this.dinasId;
    }

    this.fetch({ reset: true, params });
  },
  methods: {
    ...mapActions('iht', ['fetch', 'save']),
    ...mapActions('master', ['getMasters']),

    async onEdit() {
      this.$set(this.formulir, 'detail', this.monev);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    onSave() {
      let values = Object.assign({}, this.$refs.formulir.getValue());
      let params = new FormData();

      for (const key in values) {
        params.append(key, values[key] || '');
      }

      this.save({ params })
        .then(() => {
          this.$success('Berhasil disimpan');
          this.$refs.modal.dialog = false;
          this.fetch({ reset: true });
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
